import React from 'react';
import '../css/hero/Hero.css';
import SEO from './SEO';

const Hero = () => {
  const scrollToAbout = () => {
    const element = document.getElementById('about');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToServices = () => {
    const element = document.getElementById('services');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      <SEO 
        title="Creating Wealth Through Strategic Investments"
        description="Samapaw - Leading wealth management & property investment company in Gurugram. Expert Samapaw portfolio management, business debt provision & financial consultation services with 2+ years of experience managing ₹10Cr+ assets."
        keywords="Samapaw, Samapaw Sampatti, Samapaw wealth management Gurugram, Samapaw property investment India, Samapaw portfolio management services, Samapaw business debt provision, Samapaw financial consultation, Samapaw asset management, Samapaw investment advisory Haryana, Sama paw"
        section="home"
      />
      <section id="home" className="hero">
        <div className="hero-background"></div>
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <div className="hero-logo">
              <img src="/logo.jpg" alt="Samapaw Sampatti Logo" className="hero-logo-image" />
            </div>
            <h1 className="hero-title">
              <span className="company-name">Samapaw Sampatti</span>
              <span className="company-type">Private Limited</span>
            </h1>
            <p className="hero-motto">Creating Wealth</p>
            <p className="hero-description">
              Leading the way in strategic investment, development, and trading 
              of movable and immovable property. Your trusted partner in building 
              sustainable wealth for the future.
            </p>
            <div className="hero-buttons">
              <button onClick={scrollToServices} className="btn btn-primary">
                Our Services
              </button>
              <button onClick={scrollToAbout} className="btn btn-outline">
                Learn More
              </button>
            </div>
          </div>
          <div className="hero-stats">
            <div className="stat-item">
              <div className="stat-number">2+</div>
              <div className="stat-label">Years of Experience</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">10+</div>
              <div className="stat-label">Properties Managed</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">₹10Cr+</div>
              <div className="stat-label">Assets Under Management</div>
            </div>
          </div>
        </div>
      </div>
    </section>
    </>
  );
};

export default Hero;